import { render, staticRenderFns } from "./confirmation.component.vue?vue&type=template&id=216027f6&scoped=true"
import script from "./confirmation.component.vue?vue&type=script&lang=js"
export * from "./confirmation.component.vue?vue&type=script&lang=js"
import style0 from "./confirmation.component.vue?vue&type=style&index=0&id=216027f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216027f6",
  null
  
)

export default component.exports